/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import { v4 } from "uuid";
import { formatSeconds, toMoney } from "../../../Components/Functions";
import { routers } from "../../../Constants/routers";

const SearchResultItem = (props) => {
    const {
        name,
        title,
        header_title,
        consultation_fee,
        consultation_fee_duration,
        image, 
        gender,
        username,
        avg_rating,
        is_verified,
		address_state,
		address_lga
    } = props;
	return (
		<div 
        onClick={() => {
            window.location = routers.pages.doctor(username)
        }}
        
        className={`column is-${props?.viewmode === "List" ? 12:4} ${props?.viewmode}`} style={{ cursor: "pointer", }}>
			<div className="card p-5">
				<div className={`card-body ${props?.viewmode === "List" ? "columns" : ""}`}>
					<div className={`user-info ${props?.viewmode === "List" ? "column is-5" : ""}`} style={props?.viewmode === "List" ? { display: "flex" }: { textAlign: "center" }}>
						<div style={{
                            width: 100, height: 100, margin: props?.viewmode === "List" ? "" : "auto", position: "relative"
                        }}>
                        <img
                            src={
                                image || (gender === "MALE"
                                    ? require("../../../assets/images/doctor-placeholder-male.jpg")
                                            .default
                                    : require("../../../assets/images/doctor-placeholder-female.jpg")
                                            .default)
                            }
							style={{
								width: 100,
								height: 100,
								borderRadius: 100,
                                minWidth: 100,
                                minHeight: 100
							}}
							alt="profile image"
						/>
                        <div className={`v-badge ${is_verified ? "verified bg-success" : "unverified bg-danger"}`} >
                            <div className={`mdi mdi-${is_verified ? "check" : "close"}`} />
                        </div>
                        </div>
						<div className={`${props?.viewmode === "List" ? "ml-4" : ""}`}>
                        <h3>
							<span className="text-primary" style={{ fontWeight: "bold" }}>
								{title} {name}
							</span>{" "}
							•{" "}
							<div
								style={{
									fontSize: 12,
									fontWeight: 500,
									display: "inline-flex",
									alignContent: "center",
									alignItems: "center",
								}}
							>
								<i
									className="mdi mdi-star"
									style={{ color: "gold", fontSize: 20 }}
								/>
								<span>{avg_rating}</span>
							</div>
						</h3>
						<p style={ props?.viewmode === "List" ? {} : { height: 46, overflow: "hidden" }}>{header_title}</p>
                        </div>
					</div>
					<style>
                            {`
                                .button.is-small {
                                    font-size: 10px;
                                    font-weight: 500;
                                }

								.user-features li {
									white-space: nowrap;
									overflow: hidden;
								}
                            `}
                        </style>
					<div className={`user-features ${props?.viewmode === "List" ? "column is-3" : ""}`}>
						<ul>
							<li>
								<i className="text-primary mdi mdi-account" />{" "}
								<span>{gender}</span>
							</li>
							<li>
								<i className="text-primary mdi mdi-map-marker" />{" "}
								<span>{address_lga}, {address_state}</span>
							</li>
							<li>
								<i className="text-primary mdi mdi-store-clock" />{" "}
								<span>
									{toMoney(consultation_fee)} per{" "}
									<small>{formatSeconds(consultation_fee_duration)}</small>
								</span>
							</li>
						</ul>
					</div>
					<div className={`${props?.viewmode === "List" ? "column is-4" : ""}`}>
                      
						<div className="filters py-4">
							<div className="buttons" style={{
                                width: "max-content", margin: "auto"
                            }}>
								{[
                                    { icon: "phone", title: "Local Phone", status: props?.phone_enabled  },
                                    { icon: "whatsapp", title: "Whatsapp", status: props?.whatsapp_enabled },
                                    { icon: "email", title: "Email", status: props?.email_enabled },
                                    { icon: "video", title: "Zoom Call", status: props?.zoom_enabled },
                                    { icon: "google", title: "Google Meet", status: props?.google_meet_enabled },
                                ].map((e) => {
                                    if (e.status)
									return (
										<button
                                            title={e.title}
											className={`button is-small is-rounded search-cat-outline ${e.className}`}
											key={v4()}
                                            style={{ borderRadius: 100, width: 42, height: 42 }} 
                                            >
											<i className={`mdi mdi-${e.icon}`} style={{ fontSize: 20 }} />
										</button>
									);
								})}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SearchResultItem;
